import React from "react";
import moment from "moment";
import { ClockCircleOutlined } from "@ant-design/icons";
import ScholarshipNavbar from "components/layout-components/ScholarshipNavbar";
import ScholarshipCountDown from "./scholarship-countdown";
import DOMPurify from "dompurify";
import ScholarshipInput from "./component/ScholarshipInput";
import useBreakpoint from "hooks/useBreakpoint";
import { Footer } from "./component/Footer.js";

// Common style constants
const colors = {
  white: "#ffffff",
  black: "#000000",
  pink: "#FF33CC",
  lightGray: "#f3f3f4",
};

const Theme3 = ({ scholarshipInfo, setScolarshipInfo }) => {
  const { isMobileAndTablet } = useBreakpoint();

  const styles = {
    container: {
      overflowX: "hidden",
      height: "100dvh",
    },
    heroBanner: (isMobileAndTablet) => ({
      backgroundImage: isMobileAndTablet
        ? 'url("/new/theme3_back_mobile.webp")'
        : 'url("/new/theme3_back.webp")',
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      height: isMobileAndTablet ? "40dvh" : "50dvh",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "40px 60px",
      boxSizing: "border-box",
      position: "relative",
      color: "black",
    }),
    heroLeft: {
      flex: "1 1 60%",
      display: "flex",
      flexDirection: "column",
      justifyContent: isMobileAndTablet ? "center" : "flex-end",
      alignItems: isMobileAndTablet ? "center" : "flex-start",
      height: "100%",
    },
    title: {
      fontSize: "30px",
      fontWeight: "600",
      color: colors.white,
      margin: 0,
    },
    date: {
      fontSize: "18px",
      fontWeight: "500",
      color: colors.white,
      margin: 0,
    },
    subheading: {
      fontSize: "22px",
      fontWeight: "500",
      color: colors.white,
      margin: "8px 0 0 0",
    },
    amount: {
      fontSize: "24px",
      fontWeight: "500",
      padding: "5px 30px",
      background: "transparent",
      borderRadius: "10px",
      border: `1.5px solid #8D96FF`,
      color: colors.white,
      width: "max-content",
      margin: 0,
    },
    heroRight: (isMobileAndTablet) => ({
      flex: "1 1 40%",
      background: "rgb(255, 255, 255)",
      color: "rgb(0, 0, 0)",
      borderRadius: "10px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: isMobileAndTablet ? "relative" : "absolute",
      boxSizing: "border-box",
      top: !isMobileAndTablet ? "40px" : "0",
      width: isMobileAndTablet ? "92vw" : "560px",
      right: isMobileAndTablet ? "0" : "80px",
      boxShadow: " 0px 4px 17.6px 0px #00000040",
      ...(isMobileAndTablet && {
        left: "50%",
        transform: "translateX(-50%)",
      }),
    }),
    countdownWrapper: {
      position: "absolute",
      top: "0%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    applyText: {
      fontSize: "22px",
      fontWeight: "500",
      color: colors.black,
      margin: "12px auto",
    },
  };
  const HeroLeftSection = () => (
    <div style={styles.heroLeft}>
      <p style={styles.title}>{scholarshipInfo?.title || "No NName"} </p>
      <p style={styles.date}>
        <ClockCircleOutlined />{" "}
        {moment(scholarshipInfo?.recurrenceConfig?.start ?? new Date()).format(
          "MMMM DD, YYYY"
        )}{" "}
        -{" "}
        {moment(
          scholarshipInfo?.recurrenceConfig?.deadline ?? new Date()
        ).format("MMMM DD, YYYY")}
      </p>
      <p style={styles.subheading}>Scholarship Awards</p>
      <p style={styles.amount}>${scholarshipInfo?.awards}</p>
    </div>
  );

  const HeroRightSection = () => (
    <div style={styles.heroRight(isMobileAndTablet)}>
      <div style={styles.countdownWrapper}>
        <ScholarshipCountDown
          scholarshipInfo={scholarshipInfo}
          timeFinished={() => setScolarshipInfo(scholarshipInfo)}
          style={{ color: colors.pink }}
          mainStyle={{ background: colors.lightGray }}
        />
      </div>
      <p style={styles.applyText}>Apply now before it’s too late</p>
      <div
        style={{
          // height: "500px",
          // overflow: "hidden auto",
          width: "100%",
        }}
      >
        <ScholarshipInput
          scholarshipInfo={scholarshipInfo}
          buttonStyle={{
            textAlign: "left",
            marginTop: "40px",
          }}
          termsStyle={{
            color: "#000000",
            float: "left",
            marginLeft: "10px",
          }}
        />
      </div>
    </div>
  );

  const HeroSection = () => (
    <div style={styles.heroBanner(isMobileAndTablet)}>
      <HeroLeftSection />
      {!isMobileAndTablet && <HeroRightSection />}
    </div>
  );

  return (
    <div style={styles.container}>
      <ScholarshipNavbar scholarshipInfo={scholarshipInfo} />
      <HeroSection />
      <div
        style={{
          padding: "40px 60px",
          maxWidth: isMobileAndTablet ? "100%" : "50%",
        }}
      >
        <h3
          style={{
            fontSize: "22px",
            fontWeight: "500",
            color: colors.black,
          }}
        >
          Scholarship description
        </h3>
        <p
          className="description-text blackColor"
          style={{
            fontSize: "18px",
            fontWeight: "500",
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(scholarshipInfo?.description),
          }}
        />
      </div>

      {isMobileAndTablet && <HeroRightSection />}
      <Footer />
    </div>
  );
};

export default Theme3;
